import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const SupplierList = lazy(() => import('../Pages/SupplierList'));
const AddSupplier = lazy(() => import('../Pages/AddSupplier'));
const EditSupplier = lazy(() => import('../Pages/EditSupplier'));
const SupplierView = lazy(() => import('../Pages/SupplierView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/supplier.scss';

function SupplierRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/supplier"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <SupplierList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <SupplierList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <AddSupplier history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <EditSupplier history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/supplier/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <SupplierView history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default SupplierRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
